import PrispevokVestnikaListPage from './PrispevokVestnikaListPage';

export default PrispevokVestnikaListPage;
